import React from "react";
import {
  ArchiveOutlined,
  DeleteOutlined,
  EditOutlined,
  FileCopyOutlined,
  PauseCircleOutlineOutlined,
  PlayCircleOutlineOutlined,
  UnarchiveOutlined,
  AssignmentOutlined,
} from "@mui/icons-material";
import EmptySpinningHourglass from "../icons/EmptySpinningHourglass";

export const ActionIcons = {
  archive: <ArchiveOutlined />,
  unarchive: <UnarchiveOutlined />,
  del: <DeleteOutlined />,
  duplicateLoading: <EmptySpinningHourglass />,
  duplicate: <FileCopyOutlined />,
  edit: <EditOutlined />,
  enable: <PlayCircleOutlineOutlined />,
  disable: <PauseCircleOutlineOutlined />,
  view: <AssignmentOutlined />,
};

export const getIconForAction = (action, {isArchived, isDuplicateLoading, isEnabled}) => {
  switch (action) {
    case "archive":
      return !isArchived ? ActionIcons.archive : ActionIcons.unarchive;
    case "del":
      return ActionIcons.del;
    case "duplicate":
      return isDuplicateLoading ? ActionIcons.duplicateLoading : ActionIcons.duplicate;
    case "edit":
      return ActionIcons.edit;
    case "enablement":
      return !isEnabled ? ActionIcons.enable : ActionIcons.disable;
    case "view":
      return ActionIcons.view;
    default:
      return null;
  }
};
